const reserveRule = () => import('@/views/main/reserve/rule/rule.vue')
export default {
  path: '/main/reserve/rule',
  name: 'reserveRule',
  component: reserveRule,
  children: []
}
